export const appraisalMeetingi18n = {
  appraisalMeeting: {
    notifications: {
      target: {
        dismiss: {
          error: {
            title: 'Error while dismissing target',
            description: 'An error occurred while dismissing the target. Please, try again.',
          },
        },
        delete: {
          error: {
            title: 'Error while deleting target',
            description: 'An error occurred while deleting the target. Please, try again.',
          },
        },
        reactivate: {
          error: {
            title: 'Error while reactivating target',
            description: 'An error occurred while reactivating the target. Please, try again.',
          },
        },
        duplicate: {
          error: {
            title: 'Error while duplicating target',
            description: 'An error occurred while dismissing the target. Please, try again.',
          },
        },
      },
    },
    conclusion: {
      paymentTitle: 'Payment',
      notOnFirstOfMonthDisclaimer: 'Please, note that these payments will be due on the first available payroll period.',
      monetaryPayment: 'Monetary Target',
      pastDevelopmentTargets: 'Closed Development Targets',
      evaluation: {
        title: 'Evaluation',
        notShared: "didn't share the evaluation.",
      },
      selfReflection: {
        title: 'Self Reflection',
        notPrepared: "didn't prepare this question.",
        notShared: "didn't share this question.",
      },
    },
    meetingStepper: {
      status: {
        preparation: 'You are in the preparation',
        meeting: 'You are in the meeting',
      },
      dropdown: {
        title: 'More information',
      },
    },
    meetingStepNamesByViewId: {
      Intro: 'Overview',
      SelfReflection: 'Self-reflection',
      Evaluation: 'Evaluation',
      PastTargets: 'Past Targets',
      Payments: 'Payment',
      ContractChanges: 'Employment',
      NewTargets: 'New Targets',
      Feedback: 'Feedback',
      Notes: 'Notes',
      Conclusion: 'Conclusion',
      MeetingNotes: 'Notes',
      DevelopmentAndTargets: 'Development & Targets',
    },
    oneOffPayment: {
      title: 'One-off payment',
      description:
        'Here you will see a one-time only payment. Please note that this payment will be in addition to any New and/or Past targets payments already inserted during this meeting.',
      descriptionWithNotOnFirstOfMonthDisclaimer:
        'Here you will see a one-time only payment. Please note that this payment will be in addition to any New and/or Past targets payments already inserted during this meeting, and will be due on the first available payroll period.',
      deleteDescription: 'Are you sure you want to delete this One-off payment?',
      titleOn: 'on',
      titleIn: 'in',
      toBePaid: 'To be paid',
      comment: 'Comment',
      commentPlaceholder: 'Describe details',
      createButton: 'One-off payment',
      annualSalaryPlaceholder: 'Annual salary',
      tooltip: {
        submitting: 'Submitting',
        disabled1: 'The amount must be higher than 0',
        disabled2: 'No amount has been provided',
        disabled3: 'No comment has been provided',
        disabled4: 'Comment must be at least 2 letters long',
      },
      editButton: 'Edit',
      deleteButton: 'Delete',
      amount: 'Amount',
      paymentCycle: 'Payment cycle',
      reason: 'Reason',
      paymentDate: 'Date',
      notPlanned: 'No One-off payment scheduled.',
      paymentButtonDisabled: 'One-off payment is blocked because the employee has a low tag.',
      notifications: {
        operations: {
          created: 'created',
          edited: 'edited',
          deleted: 'deleted',
        },
        success: {
          title: 'Success',
          description: 'One off payment successfully {{operation}}',
        },
        saveErrorMessage: 'An error occurred while saving the one off payment. Please, try again.',
        deletionErrorMessage: 'An error occurred while deleting the one off payment. Please, try again.',
      },
    },
    targetCorrectionPayment: {
      title: 'Target correction payment',
      description:
        'Here you will see the payment you can insert to integrate last year or current year targets. Please note that this payment will be in addition to any New and/or Past targets payments already inserted during this meeting.',
      descriptionWithNotOnFirstOfMonthDisclaimer:
        'Here you will see the payment you can insert to integrate last year or current year targets. Please note that this payment will be in addition to any New and/or Past targets payments already inserted during this meeting, and will be due on the first available payroll period.',
      deleteDescription: 'Are you sure you want to delete this Target Correction payment?',
      titleOn: 'on',
      titleIn: 'in',
      toBePaid: 'To be paid',
      comment: 'Comment',
      commentPlaceholder: 'Describe details',
      createButton: 'Target Correction payment',
      annualSalaryPlaceholder: 'Annual salary',
      editButton: 'Edit',
      deleteButton: 'Delete',
      amount: 'Amount',
      paymentCycle: 'Payment cycle',
      reason: 'Reason',
      paymentDate: 'Date',
      notPlanned: 'No Target Correction payment scheduled.',
      referenceYear: 'Reference Year',
      paymentButtonDisabled: 'Target correction payment is blocked because the employee has a low tag.',
      notifications: {
        operations: {
          created: 'created',
          edited: 'edited',
          deleted: 'deleted',
        },
        success: {
          title: 'Success',
          description: 'Target correction payment successfully {{operation}}.',
        },
        saveErrorMessage: 'An error occurred while saving the target correction payment. Please, try again.',
        deletionErrorMessage: 'An error occurred while deleting the target correction payment. Please, try again.',
      },
    },
    objectivePayment: {
      showDeductionButton: 'Add payment deduction',
    },
    stepOverview: {
      pageDescriptionTitle: 'Welcome',
      pageDescriptionSubtitleEmployee: 'Prepare your appraisal meeting!',
      pageDescriptionSubtitleManager: 'Prepare the appraisal meeting!',
      pageDescriptionEmployee:
        'This meeting focuses on your individual development and performance targets at Reply and in your company. Start to review yourself, share information with your reviewer and give feedback on important topics you care for.',
      pageDescriptionManager:
        'This meeting focuses on the individual development and performance targets of your employee at Reply and in your company. Start to review your employee and give feedback on important topics you care for.',
      feedbackHeadlineManager: 'Notes & Feedback',
      atAGlance: 'At a Glance',
      pageDescriptionSubtitleMeeting: 'Time for the appraisal meeting!',
      pageDescriptionMeeting:
        'This meeting focuses on the individual development and performance targets of your employee at Reply and in your company. Have a look on the feedback of your employee and your notes.',
      mySelfReflection: 'My self-reflection',
      employeeSelfReflection: 'Self-reflection & Feedback',
      selfReflectionAreYouHappy: 'Are you happy with your projects or activities?',
      placeholder: 'Please write down more details',
      selfReflectionRating: 'Rate your experience',
      selfReflectionGeneralFeedback: 'Feedback',
      conclusion: 'Conclusion',
      targetsAndBonus: 'Targets & Bonus',
      contractChanges: 'Employment Changes',
      managerFeedback: 'Manager feedback',
      noFeedback: 'No feedback provided',
      skillCenterEmployee: {
        header: 'My Skill',
        desc: 'Your reviewer may be interested in your education, skills and experiences. Before starting the preparation, go to <0>My Skill</0> to keep your skill up to date. Please, ensure it reflects your current experience and skils.',
      },
      skillCenterManager: {
        header: 'Skill',
        desc: 'Go to <0>My Skill</0> to check {{employee}}’s latest skill updates.',
      },
      infoCard: {
        heading: 'You are currently in the Preparation',
        description: 'If you want to start the actual meeting, you have to confirm the preparation.',
      },
      history: {
        heading: 'Meetings History',
        date: 'Date',
        season: 'Season',
        type: 'Meeting Type',
        confirmationDate: 'Confirmation Date',
        closingDate: 'Closing Date',
        reviewer: 'Reviewer',
        conclusion: 'Conclusion',
        documents: 'Documents',
        disputedTooltip: 'This meeting was disputed.',
        disputedText: 'Disputed on',
        confirmedText: 'Confirmed on',
        unconfirmedTooltip: 'The employee did not confirm this meeting.',
        forced: 'Forced',
        forceConfirmed: 'Confirmed by {{managerFullName}} on {{date}} on behalf of {{employeeFirstName}}.',
        forceConfirmedReason: 'Reason: {{reason}}',
      },
      pageDescriptionProjects: {
        titleGecoInfo: 'Projects',
        subtitleGecoInfo: 'Projects you worked on the most',
        button: 'Show all',
        otherBarText: 'Others',
        hoursUnit: 'Hours',
        noProjectsMessage: 'Currently no projects available.',
      },
      activityList: {
        header: 'Highlights - Previous 12 months',
      },
    },
    stepSelfReflection: {
      pageDescriptionEmployee:
        'Review and reflect your project, your activities and your personal growth. Give feedback, evaluate yourself and share your thoughts with your reviewer.',
      pageDescriptionManager:
        'Your employee answered some questions regarding their personal development, activities, future growth, etc. Take your time and review the results.',
      pageDescriptionNotSharedForManager: 'Your employee has not shared their self-reflection.',
      pageDescriptionMeeting:
        'Your employee answered some questions regarding their personal development, activities, future growth, etc. Take your time and review the results together with your employee.',
      error: 'Is required!',
      manager: {
        heading: {
          notPrepared: "{{employeeName}} didn't prepare the meeting yet",
          notShared: "{{employeeName}} didn't share the self-reflection with you",
          shared: "This is {{employeeName}}'s self-reflection",
          notPreparedMeeting: "{{employeeName}} didn't prepare the meeting",
        },
        subheading: {
          notPrepared: 'These are the topics they will be asked about. You will see the answers in the meeting, once prepared.',
          notShared: 'These are the topics that were answered. You will see the answers in the meeting.',
          shared: 'These topics were asked and answered in the preparation. Have a view on the answers.',
          notPreparedMeeting:
            "These topics were asked in the preparation but not answered. You can't answer the questions in the meeting, but discuss them now.",
        },
        infoCard: {
          heading: {
            notPrepared: "{{employeeName}} didn't prepare the self-reflection yet",
            notShared: "{{employeeName}} didn't share the self-reflection",
            notPreparedMeeting: "Ask {{employeeName}} why they didn't prepare the self-reflection",
          },
          subheading: {
            notPrepared:
              "Notify {{employeeName}} to prepare the meeting, because there will be no option to answer the self-reflection in the meeting, if they didn't prepare.",
            notShared: 'You will see the answers in the meeting.',
          },
        },
      },
      employee: {
        comment: 'Do you want to give feedback for this question?',
      },
      topicCard: {
        heading: {
          development: 'Personal Development',
          project: 'Projects',
          skillsKnowledge: 'Skills & Knowledge',
        },
      },
    },
    stepDevelopmentAndTargets: {
      pageDescriptionEmployee:
        'Think about your current development goals, and also start to think of new development goals and performance targets for the upcoming year. What have you achieved? Where does your path lead you to? Think about your areas of improvement and propose possible new development goals or performance targets for your manager.',
    },
    stepTargetAndBonus: {
      pageDescriptionManager:
        'Find an overview of your employee’s performance targets below. Please give feedback, why and how your employee achieved the target or not.',
      pageDescriptionMeeting:
        'Find an overview of your employee’s performance targets and your comments below. Please give feedback, why and how your employee finally achieved the target or not.',
      employeeTargetBonusCalculator: {
        plannedTargetBonus: 'Planned target bonus',
        alreadyClosedTargetBonus: 'Already closed target bonus',
        alreadyClosedOneOffPayment: 'Already closed one-off payment',
        openTargetBonus: 'Open target bonus',
      },
      disabledButtonLabel: {
        notAllAchievedChecked: 'All targets need an achieved amount.',
        missingTargets: 'Please distribute the open target bonus completely.',
        textTooMuchTargetBonus: 'Distributed target bonus exceeds employment bonus.',
        existingOutdatedTargets: 'There are outdated targets from previous years that must be closed before confirming the meeting.',
      },
      disabledMonetaryButton: {
        targetBonusAlreadyDistributed: 'No other target bonus can be assigned.',
        targetsNotAllowedForLowEmployee: 'You cannot add a monetary target to a LOW employee.',
      },
    },
    distributionModal: {
      heading: 'Distribute the remaining bonus',
      subheadingPositive: 'Distribute remaining annual target bonus of {{amount}} to all targets',
      subheadingNegative: 'Distribute annual target bonus of {{amount}} to all targets',
      table: {
        title: 'Monetary Target',
        newBonus: 'New Bonus',
        currentBonus: 'Current bonus',
        distribute: 'Distribute {{amount}}',
        total: 'Total',
        distributeEqually: 'Distribute equally',
      },
    },
    stepNewGoals: {
      footer: {
        annualTargetBonus: 'Target Bonus',
        difference: 'Difference',
        plannedTargetBonus: 'Assigned Target Bonus',
      },
      disabledButtonLabel: {
        missingTargets:
          'Please distribute the entire annual target bonus completely and make sure that each target has at least one measurable entry before proceeding.',
        textTooMuchTargetBonus: 'Distributed target bonus exceeds employment bonus.',
      },
      pageDescriptionManager:
        'Consider the current development goals, and what can be achieved in the upcoming year. Think about areas of improvement and propose possible new development goals or performance targets to your employee.',
      pageDescriptionMeeting:
        "Start to review the new targets you and your employee proposed for the upcoming year. Think about areas of improvement and add new targets for your employee's development.",
    },
    stepContractChanges: {
      pageDescriptionManager:
        'Write down employment and other changes which have an impact on your employee, if necessary. Your changes will be shown also in the appraisal meeting. So you can discuss and inform your employee regarding these changes.',
      pageDescriptionMeeting: 'Are there any employment or other important changes you need to discuss with your employee?',
      pageHeaderMeeting: 'Review and adapt the current employment',
      contractChangeButtonDisabled: 'Contract change is blocked because the employee has a low tag.',
      modal: {
        warnings: '{{change}} was scheduled for {{date}}',
        currentMonthlySalaryOutOfRange:
          'Current salary is outside the range for the title of {{hiringOfficeCode}}{{separator}}{{department}}{{separator}}{{title}}. Please, make sure this is correct before continuing.',
        selectedMonthlySalaryOutOfRange:
          'Selected salary is outside the range for the title of {{hiringOfficeCode}}{{separator}}{{department}}{{separator}}{{title}}. Please, make sure this is correct before continuing.',
      },
    },
    stepMeetingNotes: {
      pageHeaderMeeting: 'Want to keep some notes?',
      pageDescriptionMeeting:
        'Here you can save some notes you might have taken during the meeting. They will be included in the conclusion PDF created after the appraisal.',
      textAreaPlaceHolder: 'Insert your notes here...',
    },
    stepFeedback: {
      heading: 'Almost done with the Preparation!',
      pageDescriptionPreparation: 'Almost done! This is the place for any other feedback or further ideas.',
      pageDescriptionMeeting: 'Almost done! This is the place for any other feedback.',
      placeholder: 'Write down your feedback ...',
      infoCard: {
        heading: "You didn't complete the preparation yet.",
        description: 'The following steps are not yet completed:',
        incompleteStep: 'Step {{position}}: {{stepName}} {{reason}}',
        notStarted: '(not yet started)',
        notCompleted: '(not completed)',
      },
      modal: {
        header: 'Finish your preparation',
        message1: 'Which content do you want to share with your manager before having the meeting?',
        message2: 'Self-reflection, new targets and your feedback will be automatically shared with your reviewer.',
        share: {
          targetComments: 'Your comments on targets and bonus',
          evaluation: 'Evaluation',
          selfReflection: 'Self-reflection',
          dev: 'Overview and your feedback will be automatically shared with your reviewer.',
          perf: 'Overview, new targets and your feedback will be automatically shared with your reviewer.',
          combined: 'New targets and your feedback will be automatically shared with your reviewer.',
        },
      },
      notifications: {
        error: {
          title: 'Error',
          description: 'An error occurred. Please, try again.',
        },
      },
    },
    stepPayment: {
      title: 'Target payment',
      titleOn: 'on',
      description:
        'Here you will see the payments you insert during this meeting in the "Past targets" and/or "New targets" areas. These payments will be due on the month you select above.',
      descriptionWithNotOnFirstOfMonthDisclaimer:
        'Here you will see the payments you insert during this meeting in the "Past targets" and/or "New targets" areas. These payments will be due on the first available payroll period.',
      noPaymentsDescription: 'There are currently no paid monetary targets.',
      noPaymentsHint: 'You can select the amount achieved for either past or new monetary targets inside the corresponding sections.',
      table: {
        heading: 'Target',
        footer: 'Total',
      },
      deduction: {
        title: 'Deduction',
        btn: 'Add deduction',
        modal: {
          add: 'Add deduction',
          hint: 'A deduction can be used to reduce the amount of the paid target bonus, due to a reason.',
          reason: 'Reason',
          amount: 'Amount',
        },
        reason: {
          placeholder: 'Please select reason',
          Sabatical: 'Sabatical',
          LongTermSickness: 'Long-term sickness',
          ParentalLeave: 'Parental leave',
          Other: 'Other reason',
        },
      },
      disabledButtonLabel: 'Target payment can not be negative!',
    },
    stepNotes: {
      heading: 'Almost done with the Preparation!',
      pageDescriptionPreparation:
        'This is the place for any other feedback or further ideas. After this step you can confirm the preparation and start the meeting.',
      placeholder: 'Write down your feedback ...',
      confirmBtn: 'Confirm Preparation',
      infoCard: {
        heading: "You didn't complete the preparation yet.",
        description: 'The following steps are not yet completed:',
        incompleteStep: 'Step {{position}}: {{stepName}} {{reason}}',
        notStarted: '(not yet started)',
        notCompleted: '(not completed)',
      },
      notifications: {
        error: {
          title: 'Error',
          description: 'An error occurred. Please, try again.',
        },
      },
    },
    stepConclusion: {
      heading: "You're about to finish the appraisal...",
      header: 'Please check if the changes made to the employment and targets are correct before confirming the meeting.',
      contract: 'Employment Changes',
      newTargets: 'New Targets',
      achievedTargets: 'Targets to be closed',
      dismissedTargets: 'Dismissed targets',
      oneOffPaymentInfo: 'The premium is a one-time voluntary reward that does not generate any entitlements for future payments.',
      selectPartners: {
        header: "Select with which partner you had a preliminary discussion about this employee's raises and payments.",
        placeholder: 'Select partner',
      },
      additionalParticipants: 'Additional participants in the meeting.',
      setAddtitionalParticipants: 'Take a note who was present in the meeting apart from the employee and yourself.',
      displayDate: 'Please provide the actual meeting date and time.',
      modal: {
        genericError: 'An unexpected error occurred during the meeting confirmation process.',
        reviewer: {
          header: 'Confirm the preparation',
          cardHeader: 'When you continue and confirm the preparation, you can start the meeting at any time.',
          cardDescription:
            'Please keep in mind, that no information will be sent to payroll yet. This will happen when you confirm the actual meeting.',

          confirmation: {
            header: 'Confirm the meeting',
            message1: 'After a meeting is confirmed you are not able to make any changes or to reopen the meeting.',
          },
          modalConfirmDisabledPartner:
            "Please select the partner you had a preliminary discussion about this employee's raises and payments",
          modalConfirmDisabledDisplayDate: 'Please provide the actual meeting date and time for the meeting conclusion PDF',
        },
        replyer: {
          preparation: {
            header: 'Finish your preparation',
            message1: 'Which content do you want to share with your manager before having the meeting?',
            message2: 'Self-reflection, new targets and your feedback will be automatically shared with your reviewer.',
            share: {
              targetComments: 'Comments on targets and bonus',
              evaluation: 'Evaluation',
              dev: 'Self-reflection and your feedback will be automatically shared with your reviewer.',
              perf: 'Self-reflection, new targets and your feedback will be automatically shared with your reviewer.',
              combined: 'Self-reflection, new targets and your feedback will be automatically shared with your reviewer.',
            },
          },
          confirmation: {
            header: 'Confirm your appraisal meeting?',
            message1: 'To do: fix description and add checkbox',
            message2: 'Self-reflection, new targets and your feedback will be automatically shared with your reviewer.',
          },
        },
      },
      disabledButtonLabel: {
        invalidScoreGrid: 'Evaluation grid not completed. Please recheck step "Evaluation".',
        existingOutdatedTargets:
          'There are outdated targets from previous years that must be closed before confirming the meeting. Please recheck step "Past Targets".',
        tooMuchPastTargetBonusProvided: 'Distributed target bonus exceeds employment bonus. Please recheck step "Past Targets"',
        tooLessPastTargetBonusProvided:
          'Please distribute the open employment target bonus completely. Please recheck step "Past Targets".',
        allPastObjectivesNeedToBeChecked: 'All past monetary targets need an achieved amount. Please recheck step "Past Targets".',
        tooMuchNewTargetBonusProvided: 'Distributed target bonus exceeds employment bonus. Please recheck step "New targets".',
        tooMuchNewTargetBonusProvidedInAppraisalUpdate:
          'Distributed target bonus exceeds employment bonus. Please recheck step "Development & Targets".',
        tooLessNewTargetBonusProvided:
          'Please distribute the entire annual target bonus completely and make sure that each target has at least one measurable entry before proceeding. Please recheck step "New Targets".',
        tooLessNewTargetBonusProvidedInAppraisalUpdate:
          'Please distribute the entire annual target bonus completely and make sure that each target has at least one measurable entry before proceeding. Please recheck step "Development & Targets".',
        targetBonusToBePaidNegative: 'Target payment can not be negative! Please recheck step "Payment".',
        invalidObjectivePaymentDate:
          'There is a Target Payment whose pay out month can no longer be selected. Please, review the step “Payments"',
        missingObjectivePaymentDate: 'Missing next target payment date! Please recheck step "Payment".',
        invalidOneOffPaymentDate:
          'There is a One-Off Payment whose pay out month can no longer be selected. Please, review the step “Payments"',
        notAllMeetingsStepsCompleted: 'All meeting steps need to be completed to confirm the meeting.',
        invalidEmployeeSkillStatus:
          "The employee skill center must be updated. Tell {{employeeName}} to update their skills before confirming the meeting. Check Overview step to learn more about {{employeeName}}'s education, skills and experience",
        existingDevObjectivesToBeClosed:
          'All past development targets must be closed or dismissed prior to meeting confirmation. Please recheck step "Past Targets".',
        existingContractChangesForLowEmployee:
          'A LOW employee cannot be subject to employment changes. Delete existing employment changes to confirm the meeting.',
        existingWrongNewTargets:
          'A LOW employee cannot have monetary targets. Delete existing monetary targets to be able to confirm the meeting.',
        existingOneOffPaymentsForLowEmployee:
          'You cannot add one-off payment to a LOW employee. Delete existing one-off payment to be able to confirm the meeting.',
        existingWrongTCPaymentsForLowEmployeeToBeChanged:
          'You cannot add target correction payment with reference year {{year}} to a LOW employee. Change existing target correction payment reference year to be able to confirm the meeting.',
        existingWrongTCPaymentsForLowEmployeeToBeRemoved:
          'You cannot add target correction payment with reference year {{year}} to a LOW employee. Delete existing target correction payment to be able to confirm the meeting.',
        atLeastOnePastMonetaryTargetWithWrongCurrency:
          'There is at least one past monetary target whose currency differs from the one of the employee contract. Please, fix this issue by using the proper action button inside the section.',
        atLeastOneMonetaryTargetWithWrongCurrency:
          'There is at least one monetary target whose currency differs from the one of the employee contract. Please, fix this issue by using the proper action button inside the section.',
        unknownConversionRate:
          'Currency for current contract is {{currentContractCurrency}}. No conversion rate found for these currencies: {{unknownCurrencies}}',
        invalidTargetCorrectionPaymentDate:
          'There is a Target Correction Payment whose pay out month can no longer be selected. Please, review the step “Payments"',
        invalidGovernmentJobTitle:
          'There is an employment change containing an invalid Government Job Title. Please, review the step "Employment"',
      },
      meeting: {
        contract: {
          header: 'Employment Changes',
          annualTargetBonus: 'Annual Target Bonus',
          grossAnnualSalary: 'Gross Annual Salary',
        },
        pastObjectives: {
          header: 'Past Targets',
        },
        newObjectives: {
          header: 'New Targets',
        },
      },
    },

    employeeCloseMeetingModal: {
      title: 'Close your appraisal meeting',
      meetingInfo: 'From {{date}} with {{reviewer}}',
      message: 'Download and view your meeting conclusion documentation',
      optionApprove: 'I viewed the conclusion and approve of it.',
      optionDispute: 'I viewed the conclusion and do NOT approve of it.',
      feedBackToHRCaseApproval: 'Do you want to send feedback to HR?',
      feedBackToHRCaseDispute: 'Please add feedback for HR:',
      placeholder: 'Please tell us your feedback ...',
      viewConclusionPdfTooltip: {
        ready: 'View Conclusion PDF',
        notReady: 'View Conclusion PDF (not yet generated)',
      },
      selectionRequired: 'Please select one option',
      feedbackRequired: 'Feedback for HR is required when you do not approve of the meeting.',
      feedbackTooShort: 'Feedback for HR is too short',
      confirm: 'Confirm Meeting',
      dispute: 'Dispute Meeting',
      disputeInfo:
        'Disputing the appraisal only rejects the new targets. The evaluation, payments and employment changes can only be modified in an appraisal update.',
      confirmButtonTooltip: {
        genericMessage: 'The meeting must be either approved or disputed',
        allFieldsRequired: 'All fields must be filled up',
        feedbackTooShort: 'Inserted feedback is too short',
      },
    },
    pdfDownloadPopover: {
      documents: 'Documents',
      attachments: 'Attachments',
      preparation: 'Preparation PDF',
      conclusion: 'Conclusion PDF',
    },
    stepNext: 'next',
    stepPrevious: 'back',
    buttons: {
      goalsAndBonus: 'Targets & Bonus',
      feedback: 'Feedback',
      newGoals: 'New target',
      addTargets: 'Add targets',
      distribute: 'Distribute',
      confirm: 'Confirm',
      edit: 'Edit',
      overview: 'Overview',
      contractChanges: 'Employment changes',
    },
    targetsTemplate: {
      chooseFromTemplate: 'Choose from template',
      chooseFromTemplateTooltip:
        'No existing templates to choose from. Partners can create new target templates inside the “Target Templates” section.',
      templatesNotFound: 'No target templates found.',
      chooseFromTemplatePlaceholder: 'Search templates',
    },
    targetBonusOverview: {
      from: 'from {{date}}',
      annualTargetBonusForYear: 'Target bonus for {{year}}',
      targetBonusZeroForLow: 'The target bonus is zero for a low employee.',
      annualAmount: 'Annual amount',
      proratedAmount: 'Prorated amount',
      flexibleBonusAmount: 'Edited bonus amount',
      editBonusAmount: 'Edit bonus amount',
      editBonus: 'Edit bonus',
      bonusAmountDescription:
        "Choose the bonus amount for the current appraisal season. The amount must be between the maximum allowed and the pro rata calculated from the employee's date of hire.",
      bonusAmountNote:
        'Please note that once the annual target amount is modified, and the appraisal is confirmed, no further changes will be possible.',
      bonusAmount: 'Bonus amount for {{year}}',
      plannedTargetBonus: 'Assigned target bonus',
      bonusAlreadyPaid: 'Bonus already paid',
      differenceToDistribute: 'Difference to be assigned',
      distributionButton: {
        invalidCurrency: 'At least one active monetary target with wrong currency',
      },
    },
    prorataTooltip: {
      heading: 'Based on: ',
      partialCalcDescription: '{{amount}} (annual: {{annualAmount}}) from {{date}}',
      separator: '; ',
    },
    paymentOverview: {
      list: {
        alreadyClosed: 'Already closed targets',
        target: 'Target Bonus',
        extra: 'One-off Payment',
        total: 'Total',
      },
      item: {
        title: 'Title',
        reached: 'Reached',
        paid: 'Paid',
        payday: 'Payday',
        action: 'Actions',
        bonus: 'Bonus',
        toBePaid: 'To be paid in',
      },
    },
    closedTargetsOverview: {
      header: 'Already closed targets',
      table: {
        title: {
          monetary: 'Monetary targets',
          development: 'Development targets',
          tasks: 'Tasks',
        },
        target: 'Target amount',
        achievedMonetary: 'Reached',
        achievedDevelopment: 'Reached',
        amount: 'Amount',
        closedDate: 'Closed on',
        actions: 'Actions',
      },
      item: {
        title: 'Title',
        reached: 'Reached',
        amount: 'Amount',
        target: 'Target',
        result: 'Result',
        closedDate: 'Closed meeting date',
        action: 'Actions',
        toBePaid: 'To be paid in',
        attachment: 'Attachment',
      },
    },
    pastGoals: {
      form: {
        bonus: 'Bonus',
        toBePaid: 'To be paid',
        reached: 'Reached',
      },
      textAreaHeadline: {
        employeePrep: 'What did you do to achieve this target?',
        managerPrepBeginning: 'What did',
        managerPrepEnd: 'do to achieve this target?',
        meetingView: 'Comment',
      },
      cardWithAvatar: {
        you: 'You',
        setAsScore: 'Set as score',
      },
    },
    selfReflection: {
      questions: {
        srQuestion1: 'How satisfied are you generally with your personal development at Reply? ',
        srQuestion2: 'How much does your company support you in achieving your personal development?',
        srQuestion3: 'How satisfied have you been with your projects in the last year?',
        srQuestion4: 'Do you use new skills and knowledge in your projects?',
        srQuestion5: 'How did you share your skills and knowledge with other Replyers or external people? (Optional)',
      },
      booleans: {
        srQuestion5Bool1: 'Social Network Events',
        srQuestion5Bool2: 'Conferences or Meetups',
        srQuestion5Bool3: 'Reply Newbies',
        srQuestion5Bool4: 'Internal Company Events',
        srQuestion5Bool5: 'Blogposts and Articles',
      },
    },
    contract: {
      general: {
        title: 'GENERAL',
      },
      financial: {
        title: 'FINANCIAL & BENEFITS',
      },
      title: 'Title',
      workDays: 'Workdays',
      careerPath: 'Career path',
      hoursPerWeek: 'Working hours',
      vacationDays: 'Vacation days',
      annualSalary: 'Annual salary',
      monthlySalary: 'Monthly salary',
      annualBonus: 'Target bonus for {{year}}',
      salary: 'Annual salary',
      bonus: 'Annual target bonus',
      bonusPrepayment: 'Pre-payment',
      valuableHours: 'Valuable hours',
      variableSalaryHours: 'Variable component',
      contractType: 'Employment type',
      leaveEntitlement: 'Leave entitlement',
      leaveEntitlementMeasurement: 'days',
      employeeLevel: 'Level',
      nationalReferenceLevel: 'NC - Level',
      cancellationType: 'Resignation type',
      endOfContract: 'Leaving Date',
      companyCar: 'Company car',
      companyCarDeduction: 'Deduction',
      companyCarAllowance: 'Car allowance',
      contractHistory: 'History',
      hiringOffice: 'Hiring Office',
      governmentJobTitle: 'Government Job Title',
      changes: {
        deleteDescription: 'Are you sure you want to delete this Employment change?',
        note1: 'Please note: the option to do an employment change can be different depending on the selected month.',
        note2: 'When entering amounts, keep in mind that percentages and K amounts are not a supported format.',
        note3: 'The changes you add are related to the Appraisal Season {{appraisalSeasonYear}}.',
        seniorManagerNote: 'Please check the designation was already approved before selecting the title Senior Manager.',
        warning: 'Employment data is invalid. Please inform HR!',
        tableHeadline: 'Employment changes',
        notOnFirstOfMonthDisclaimer:
          'Please, note that these changes to the employment agreement will be valid starting from the first available payroll period.',
        table: {
          from: 'From',
          change: 'Change',
          confirmedAt: 'Confirmed at',
          footerText: '{{range}}-{{range1}} of {{total}} employment changes',
          salary: 'Annual salary',
          bonus: 'Annual target bonus',
          carAllowance: 'Car allowance',
          employeeLevel: 'Level',
          employeeNationalLevel: 'National contract level',
          governmentJobTitle: 'Government Job Title',
          empty: 'No employment change scheduled.',
          newSalary: 'New annual salary',
          newBonus: 'New annual target bonus',
          newEmployeeLevel: 'New employee level',
          careerPath: 'Careerpath',
          tooltips: {
            invalidGovernmentJobTitle: 'This change has an invalid Government Job Title. Please, change it.',
          },
        },
        form: {
          salary: 'Salary',
          bonus: 'Bonus',
          validFrom: 'Valid from',
          validFromPlaceholder: 'Please select a month',
        },
        action: {
          createTooltip: 'Add employment change',
          createTooltipDisabled: 'You already added all possible changes for {{employeeName}}.',
          createBtn: 'Employment change',
          delete: 'Delete employment change',
          edit: 'Edit employment change',
        },
        current: {
          header: 'Current Employment',
        },
        change: {
          header: 'Change to',
          careerPathSummary: 'Summary',
        },
        confirmBonusAmountModal: 'Confirm target bonus amount ',
        confirmBonusAmountModalT1: 'You inserted a employment change to the target bonus valid from <0>{{date}}</0>.',
        confirmBonusAmountModalT2:
          'Please, note that the amount you inserted will be considered pro rata based on the remaining months in the year.',
        confirmBonusAmountModalT3:
          "If you'd like to set the total amount for the whole year, consider editing the employment change starting month to January.",
        unknownCurrencyConversion:
          "Could not find currency conversion from Government Job Titles' currencies [{{governmentJobTitleCurrencies}}] to current salary currency {{currentSalaryCurrency}}.",
        notifications: {
          create: {
            success: {
              title: 'Success',
              description: 'Employment change successfully created.',
            },
          },
          update: {
            success: {
              title: 'Success',
              description: 'Employment change successfully updated.',
            },
          },
          delete: {
            success: {
              title: 'Success',
              description: 'Employment change successfully deleted.',
            },
            error: {
              title: 'Error while deleting employment change',
              description: 'An error occurred while deleting the employment change. Please, try again.',
            },
          },
        },
      },
    },
    evaluation: {
      evaluationValue: 'Evaluation',
      employeePageDescription:
        'Reflect on your past year’s performance. You can find the 18 skills and characteristics, based on the Reply values, below. Please assign a score for each skill from 1 (low) to 10 (high).',
      employeePageDescription1:
        'Please base your scores on the following: 1-4 – you are working below expectations; 5 – most expectations were met but there is room for improvement; 6 – you are meeting all the expectations in your role at your level. It is also used to signify ‘not applicable’; 7-8 – your performance exceeds expectations; 9-10 – outstanding; your performance consistently and significantly exceeds expectations.',
      employeePageDescription2:
        'When scoring, please consider your job level, focus of your role and experience, as the expectations for each of these skills naturally differ depending on your role. Where a skill does not apply within your responsibilities (e.g., people management for a Consultant) then please score 6.',
      managerPageDescription:
        'Reflect on the past year’s performance of your REPLYER. You can find the 18 skills and characteristics, based on the Reply values, below. Please assign a score for each skill from 1 (low) to 10 (high).',
      managerPageDescription1:
        'Please note that a score of: 1-4 – they are working below expectations; 5 – most expectations were met but there is room for improvement; 6 – they are meeting all the expectations in their role at their level. It is also used to signify ‘not applicable’; 7-8 – their performance exceeds expectations; 9-10 – outstanding; their performance consistently and significantly exceeds expectations.',
      managerPageDescription2:
        'When scoring, please consider your REPLYER’s level, role, and experience, as the expectations for each of these skills naturally differ depending on their role. Where a skill does not apply within their responsibilities (e.g., people management) then please score 6.',
      managerPageDescription3:
        'If the values below were prefilled when entering the preparation, it means the company manager already had a proposal for these evaluation grades. Please contact them for further information.',
      meetingPageDescription:
        'Reflect on the past year’s performance of your REPLYER. You can find the 18 skills and characteristics, based on the Reply values, below. Please assign a score for each skill from 1 (low) to 10 (high).',
      meetingPageDescription1:
        'Please note that a score of: 1-4 – they are working below expectations; 5 – most expectations were met but there is room for improvement; 6 – they are meeting all the expectations in their role at their level. It is also used to signify ‘not applicable’; 7-8 – their performance exceeds expectations; 9-10 – outstanding; their performance consistently and significantly exceeds expectations.',
      meetingPageDescription2:
        'When scoring, please consider your REPLYER’s level, role, and experience, as the expectations for each of these skills naturally differ depending on their role. Where a skill does not apply within their responsibilities (e.g., people management) then please score 6.',
      pastYear: 'Last Result',
      disabledButtonLabel: 'All of the input fields need to be filled before proceeding',
      managerPreparation: {
        infoCard: {
          heading: {
            notPrepared: "{{employeeName}} didn't prepare the evaluation yet",
            notShared: "{{employeeName}} didn't share the evaluation",
            notPreparedMeeting: "Ask {{employeeName}} why they didn't prepare the evaluation",
          },
          subheading: {
            notPrepared: 'Notify {{employeeName}} to prepare the meeting.',
          },
        },
      },
      you: 'You',
      footer: {
        lastScore: 'Last Score',
        evaluationScore: 'Evaluation Score',
        evaluationScoreTooltip: 'Calculate Evaluation Score',
        employeeScore: "{{name}}'s score",
      },
      grid: {
        scaleInformation: {
          firstScale: '1 - needs improvement',
          secondScale: '6 - meets expectation',
          thirdScale: '10 - exceeds expectation',
          meetingAdditionalInfo: 'If a category does not fit the employees job description please choose 6',
          managerAdditionalInfo: 'If a category does not fit the employees job description please choose 6',
          employeeAdditionalInfo: 'If a category does not fit your job description please choose 6',
        },
        category: {
          Customer: 'Customer',
          Speed: 'Speed',
          Teamwork: 'Teamwork',
          Excellence: 'Excellence',
          Innovation: 'Innovation',
          HumanValues: 'Human values',
        },
        headline: {
          Customer_1: 'Customer Focus',
          Customer_2: 'Responsibility',
          Customer_3: 'Communication with clients',
          Customer_4: 'Proactivity',
          Customer_5: 'Business Development',
          Speed_1: 'Problem Solving',
          Speed_2: 'Organizational Capability',
          Speed_3: 'Target Focus',
          Teamwork_1: 'Knowledge Sharing',
          Teamwork_2: 'People Management ',
          Teamwork_3: 'Communication with colleagues',
          Excellence_1: 'Competences and Specialisations',
          Excellence_2: 'Job Quality',
          Excellence_3: 'Continuous Learning Excellence',
          Innovation_1: 'Innovation Propensity',
          Innovation_2: 'Continuous Learning Innovation',
          HumanValues_1: 'Adherence to Reply Values (Ethics, Reliability, Transparency, Honesty)',
          HumanValues_2: 'Culture and Principles Alignment',
        },
        description: {
          manager: {
            Customer_1:
              "The REPLYER understands and listens to their clients' needs and provides the most suitable solution in a timely manner. They have the knowledge to promote Reply competently and professionally. They are aware of Reply organization and our product portfolio.",
            Customer_2:
              "The REPLYER takes ownership for the successful completion of their assigned work to a high standard and within a reasonable time, consistently informing the relevant stakeholders of the project's status. They proactively advise stakeholders if a deadline cannot be met, or the quality of the work will not be as expected.",
            Customer_3:
              'The REPLYER appears solution-oriented, clear, friendly and respectful with clients in order to strengthen or build customer relationships. The REPLYER is transparent, honest, and respectful with clients. They share all relevant information within the team and provide constructive feedback.',
            Customer_4:
              "The REPLYER has an awareness of their project's challenges and proactively involves relevant stakeholders at an early stage as needed. They work independently and autonomously. They anticipate any upcoming challenges and proactively provide a solution.",
            Customer_5:
              "The REPLYER understands the clients' needs and pro-actively seeks innovative solutions. They promote Reply with professionalism and a high degree of competence. Thinking creatively, they find new opportunities Reply.",
            Speed_1: 'The REPLYER deals with problems effectively. They identify the most effective solution and implement it efficiently.',
            Speed_2:
              'The REPLYER can effectively organize and structure their workload and balance multiple competing priorities. They interact with both internal and external stakeholders effectively and professionally. They can work with ambiguity and confidently react to change.',
            Speed_3:
              'The REPLYER approaches tasks and challenges focusing on the important points. They also focus on reaching agreed solutions regarding time, quality, and costs.',
            Teamwork_1: 'The REPLYER is helpful, collaborative and shares their skills and knowledge with their co-workers.',
            Teamwork_2:
              'The REPLYER understands the skills, characteristics and needs of the team and manages them accordingly. They challenge, support, and guide their team to success. They are confident managing individual and team efforts. They identify the strengths of others and help their team improve through formal or informal coaching. They promote positive behavior within Reply.',
            Teamwork_3:
              'The REPLYER is transparent, honest, and respectful with colleagues. They share all relevant information within the team and provide constructive feedback.',
            Excellence_1:
              'The REPLYER possesses all technical and other required skills necessary for their role. They strive for excellence in their field of expertise.',
            Excellence_2: 'The REPLYER completes their tasks in the best possible quality.',
            Excellence_3:
              'The REPLYER actively searches for the best solution and new ways to succeed in the project. They are curious and continuously expand their field of expertise and skills.',
            Innovation_1:
              'The REPLYER has an innovative mindset. They show a positive attitude towards technical, social, and methodological innovations and cultivate their curiosity by investing time in staying up to date.',
            Innovation_2:
              'The REPLYER actively seeks for knowledge from internal and external resources. They are curious and continuously expand their field of expertise and skills. They take responsibility for their personal and professional development.',
            HumanValues_1: 'The REPLYER lives and shares the REPLY values and lives up to them.',
            HumanValues_2:
              'The REPLYER feels like a part of the REPLY culture. They actively participate in contributing to the network concept and leave their footprint within REPLY.',
          },
          employee: {
            Customer_1:
              "I understand and listen to my clients' needs and I provide the most suitable solution in a timely manner. I have the knowledge to promote REPLY competently and professionally and therefore I am aware of REPLY organization and our product portfolio.",
            Customer_2:
              'I take ownership for the successful completion of the assigned workload in the best quality and time. I continuously inform the relevant stakeholders about the project status and will actively involve them if a deadline or overall quality cannot be met.',
            Customer_3:
              'I appear solution-oriented, clear, friendly and respectful with clients in order to strengthen or build customer relationships. I am transparent, honest and respectful with clients.',
            Customer_4:
              'I am aware of the project challenges and will involve the stakeholders in an early stage if needed. I work independently and autonomously. I anticipate upcoming challenges and proactively provide a solution.',
            Customer_5:
              "I understand the clients' needs and I find the right solutions following innovative paths. I promote REPLY with professionalism and competence. Thinking outside the box, I find possibilities and future projects for REPLY.",
            Speed_1: 'I deal with problems effectively. I identify the most effective solution and I implement it efficiently.',
            Speed_2:
              "I have the ability to organize and structure my tasks and I deal with internal and external customers effectively. My reactions to changes are well-considered and flexible, and I invest my available time into fulfilling my clients' requests.",
            Speed_3:
              'I approach tasks and challenges focusing on the important points. I also focus on reaching agreed solutions regarding time, quality and costs.',
            Teamwork_1: 'I am helpful, collaborative and share my skills and knowledge with my co-workers.',
            Teamwork_2:
              'I support, guide and understand the needs of my team respecting the individual skills and characteristics of each member. I recognize both - individual and group efforts. I provide coaching and I identify the strengths of others. I challenge and manage them accordingly. I promote positive behaviour within REPLY.',
            Teamwork_3:
              'I am transparent, honest and respectful with colleagues. I share all relevant information within the team and I provide constructive feedback.',
            Excellence_1:
              'I possess all technical and other required skills necessary for my role. I strive for excellence in my field of expertise.',
            Excellence_2: 'I complete my tasks in the best possible quality.',
            Excellence_3:
              'I actively search for the best solution and new ways to succeed in the project. I am curious and continuously expand my field of expertise and skills.',
            Innovation_1:
              'I have an innovative mindset. I show a positive attitude towards technical, social and methodological innovations and I cultivate my curiosity by investing time in staying up-to-date.',
            Innovation_2:
              'I actively seek for knowledge from internal and external resources. I am curious and I continuously expand my field of expertise and my skills. I take responsibility for my personal and professional development.',
            HumanValues_1: 'I live and share REPLY values and live up to them.',
            HumanValues_2:
              'I feel part of REPLY culture. I actively participate in contributing to the network concept and leave my mark on REPLY.',
          },
        },
      },
    },
  },
}
